module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Speaker-be79e06be65447bc46af8204eb4d3375.svg";